import isNil from 'ramda/src/isNil'
import settings from '../settings'
import { stripFirstChar } from '../util/helpers'

const {
  wrapperElementDataAttribute,
  wrapperElementId,
  wrapperElementTypeAttribute,
  wrapperElementDataAliasValues,
} = settings

export const getFormMeta = () => {
  const wrapperElement = document.querySelector(`#${wrapperElementId}`)
  let wrapperExists = false
  let slug = null
  let isInEditMode = false
  let submitSlug = null
  let formAddress = null
  let utmTracker = null
  let formType = null
  let isEmbeddedNps = false
  let adminAccess = false
  let shouldPostMessageToParent = false
  let isAppBlock = false
  let xAppId = null
  let aliasFieldValues = ''
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams = urlParams.get('utm_source')
  if (wrapperElement) {
    wrapperExists = true
    // read the slug from wrapper tag
    slug = wrapperElement.getAttribute(`data-${wrapperElementDataAttribute}`)
    if (utmParams) utmTracker = window.location.search
    // in case there is no slug, read the form address from url
    if (!slug) formAddress = stripFirstChar(window.location.pathname)

    // check to see if the form is in edit mode
    const mode =
      wrapperElement.getAttribute('data-formz-mode') || urlParams.get('mode')
    if (mode && mode === 'edit') {
      isInEditMode = true
      // get the submitSlug if it is in edit mode, it will be set by adminPanel module
      submitSlug =
        wrapperElement.getAttribute('data-formz-submitSlug') ||
        urlParams.get('submit-slug')
    }
    formType = wrapperElement.getAttribute(
      `data-${wrapperElementTypeAttribute}`
    )

    if (formType === 'nps' && slug) {
      isEmbeddedNps = true
    }
    // check if the form has admin access. On admin access the form loads more data, like admin_only fields
    adminAccess = wrapperElement.getAttribute('data-formz-access') === 'admin'

    /*
    This flag is used to store the result of form events like successful submissions on session storage so that embedded forms (iframe) and their parent form can share data.
    Using postMessage is another way, but it isn't a reliable approach and caused many issues. 
    This solution replaces the dispatching events. 
    */
    shouldPostMessageToParent = urlParams.get('formaloo_post_to_parent')

    /**
     *
     */
    isAppBlock = wrapperElement.getAttribute('data-is-block') === 'true'

    xAppId = wrapperElement.getAttribute('data-app-id')
    /*
    get alias or hidden fields value from wrapper element.
    The format is like: data-alias-fields="alias_1=value1&alias_2=value2" exactly like how you set the url params
     */
    const params = wrapperElement.getAttribute(
      `data-${wrapperElementDataAliasValues}`
    )
    if (!isNil(params)) {
      aliasFieldValues = params
    }
  } else {
    // we dont even have a wrapper !
    wrapperExists = false
  }

  return {
    slug: slug ? slug : null,
    formAddress: formAddress ? formAddress : null,
    utmTracker: utmTracker ? utmTracker : null,
    wrapperExists,
    wrapperElement,
    wrapperElementId,
    isInEditMode,
    submitSlug,
    formType,
    isEmbeddedNps,
    adminAccess,
    shouldPostMessageToParent,
    isAppBlock,
    xAppId,
    aliasFieldValues,
  }
}
